// FETCH ALL PROPERTIES FROM PIM DETAILS
export const FETCH_PIM_DETAILS_REQUEST = 'FETCH_PIM_DETAILS_REQUEST';
export const FETCH_PIM_DETAILS_SUCCESS = 'FETCH_PIM_DETAILS_SUCCESS';
export const FETCH_PIM_DETAILS_FAILURE = 'FETCH_PIM_DETAILS_FAILURE';

export const FETCH_PIM_DETAILS_INWARD_NO_REQUEST = 'FETCH_PIM_DETAILS_INWARD_NO_REQUEST';
export const FETCH_PIM_DETAILS_INWARD_NO_SUCCESS = 'FETCH_PIM_DETAILS_INWARD_NO_SUCCESS';
export const FETCH_PIM_DETAILS_INWARD_NO_FAILURE = 'FETCH_PIM_DETAILS_INWARD_NO_FAILURE';

// CREATE PROPERTIES FOR PIM DETAILS
export const CREATE_PIM_DETAILS_REQUEST = 'CREATE_PIM_DETAILS_REQUEST';
export const CREATE_PIM_DETAILS_SUCCESS = 'CREATE_PIM_DETAILS_SUCCESS';
export const CREATE_PIM_DETAILS_FAILURE = 'CREATE_PIM_DETAILS_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_PIM_DETAILS = 'CREATE_USER_FORM_PIM_DETAILS';

// UPDATE PROPERTIES FOR PIM DETAILS
export const UPDATE_PIM_DETAILS_REQUEST = 'UPDATE_PIM_DETAILS_REQUEST';
export const UPDATE_PIM_DETAILS_SUCCESS = 'UPDATE_PIM_DETAILS_SUCCESS';
export const UPDATE_PIM_DETAILS_FAILURE = 'UPDATE_PIM_DETAILS_FAILURE';

// FETCH SINGLE PIM_DETAILS
export const FETCH_SINGLE_PIM_DETAILS_REQUEST = 'FETCH_SINGLE_PIM_DETAILS_REQUEST';
export const FETCH_SINGLE_PIM_DETAILS_SUCCESS = 'FETCH_SINGLE_PIM_DETAILS_SUCCESS';
export const FETCH_SINGLE_PIM_DETAILS_FAILURE = 'FETCH_SINGLE_PIM_DETAILS_FAILURE';

// DELETE PROPERTIES FOR PIM DETAILS
export const DELETE_PIM_DETAILS_REQUEST = 'DELETE_PIM_DETAILS_REQUEST';
export const DELETE_PIM_DETAILS_SUCCESS = 'DELETE_PIM_DETAILS_SUCCESS';
export const DELETE_PIM_DETAILS_FAILURE = 'DELETE_PIM_DETAILS_FAILURE';

// USERFORM RESET

export const PIM_DETAILS_USERFORM_RESET = 'PIM_DETAILS_USERFORM_RESET';
